import { render, staticRenderFns } from "./funnel-chart-widget.vue?vue&type=template&id=3997b1f4"
import script from "./funnel-chart-widget.vue?vue&type=script&lang=js"
export * from "./funnel-chart-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3997b1f4')) {
      api.createRecord('3997b1f4', component.options)
    } else {
      api.reload('3997b1f4', component.options)
    }
    module.hot.accept("./funnel-chart-widget.vue?vue&type=template&id=3997b1f4", function () {
      api.rerender('3997b1f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/chart-widget/funnel-chart-widget.vue"
export default component.exports